module.exports = __webpack_public_path__ + "img/frame_advert1.165aa72b.png";